import { UseOrderbookKey } from './useOrderbook.types';
import {
  UseOrderbookOnMessage,
  useOrderbookReceiver,
} from './useOrderbookReceiver';
import { useOrderbookSender } from './useOrderbookSender';
import { OrderbookSymbolsKeyEnum } from './orderbook.store.types';

export const useOrderbook = (
  symbols: string[],
  stateKey: OrderbookSymbolsKeyEnum,
  actionKey: UseOrderbookKey,
  onMessage: UseOrderbookOnMessage,
) => {
  useOrderbookSender(stateKey, symbols);
  useOrderbookReceiver(symbols, actionKey, onMessage);
};
